import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { ClientProvider } from './contexts/ClientContext';
import ErrorBoundary from './components/ErrorBoundary';
import './components/SpecularButton.css';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <ClientProvider>
        <App />
      </ClientProvider>
    </ErrorBoundary>
  </React.StrictMode>
);
